<template>
<div>
    <div class="mdl-grid" v-if="foods != null && foods.length > 0">
        <h6 class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone">Hlavní jídla</h6>

        <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">Kód</div>
        <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">Jméno</div>
        <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">Počet</div>

        <div v-for="(foodItem, index) in this.foods" class="mdl-grid mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone"
             :class="{'dark-row': (index % 2) === 0}" :key="foodItem.food.foodId">
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">{{foodItem.food.foodCode}}</div>
            <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">{{foodItem.food.name}}</div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">{{foodItem.count}}</div>

            <div v-for="option in foodItem.foodOptions" class="mdl-grid mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone"
                 :key="JSON.stringify(option.first)" style="padding: 0px; height: 22px">
                <div class="mdl-cell mdl-cell--4-offset-desktop mdl-cell--4-offset-tablet mdl-cell--2-offset-phone
                mdl-cell--4-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone" style="margin-bottom: 0px; margin-top: 0px; height: 20px">{{getOptionsName(option.first)}}</div>
                <div class="mdl-cell mdl-cell--4-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone" style="margin-bottom: 0px; margin-top: 0px; height: 20px">{{option.second}}</div> <!--/{{foodItem.count}}-->
            </div>
        </div>
    </div>
    <div v-else>
        Žádná objednaná jídla.
    </div>
    <div class="mdl-grid" v-if="soups != null && soups.length > 0">
        <h6 class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone">Polévky</h6>
        <div v-for="(soupItem, index) in this.soups" class="mdl-grid mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone" :class="{'dark-row': (index % 2) === 0}" :key="soupItem.first.soupId">
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">{{soupItem.first.soupCode}}</div>
            <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone">{{soupItem.first.name}}</div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">{{soupItem.second}}</div>
        </div>
    </div>
    <div v-else>
        Žádné objednané polévky.
    </div>
</div>
</template>

<script>
    import axios from "axios"
    import config from "../config"

    export default {
        name: "MenuSummary",
        data: function () {
            return {
                foods: null,
                soups: null
            }
        },
        props: {
            menuId: Number
        },
        methods: {
            getOptionsName(options) {
                var name = ""
                var counter = 0
                for (const option of options) {
                    name += option.foodOptionType.name
                    counter++
                    if (counter < options.length) {
                        name += " + "
                    }
                }
                return name
            },
            load: function () {
                axios
                    .get(config.host + "/v1/menu/summary/" + this.menuId)
                    .then(response => {
                        //window.console.log(response);
                        this.foods = response.data.foods;
                        this.soups = response.data.soups;
                    })
            }
        },
        mounted() {
            if(this.menuId !== undefined)
                this.load();
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            menuId: function (oldVal, newVal){
                this.load();
            }
        }
    }
</script>

<style scoped>
    .dark-row {
        background: #F6F6F6;
    }
</style>